import { useEffect } from "react";
import { useDashboardWs } from "../context/DashboardContext";

const PRESENCE_INTERVAL_MS = 30_000;

export function useDashboardPresenceReport(topic: string, path: string) {
  const { sendPresence, wsReady } = useDashboardWs();

  useEffect(() => {
    if (!wsReady) return;
    sendPresence(topic, path);
    const id = window.setInterval(() => sendPresence(topic, path), PRESENCE_INTERVAL_MS);
    return () => window.clearInterval(id);
  }, [topic, path, sendPresence, wsReady]);
}
